/** "PR abierto": tilde verde, título, cuerpo y link al PR. Lo comparten los tres formularios del Brain (cliente nuevo, agregar canal, perfil PML). */
import type { ReactNode } from 'react';
import { CheckCircle2, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PrOpenedNotice({ prUrl, title, body, children }: { prUrl: string; title: string; body: ReactNode; children?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className="text-center space-y-4 py-4">
      <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mx-auto"><CheckCircle2 className="w-6 h-6 text-emerald-600" /></div>
      <div>
        <p className="font-semibold text-gray-900">{title}</p>
        <p className="text-sm text-gray-500 mt-1">{body}</p>
      </div>
      <a href={prUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm text-[#FF6B6B] hover:underline font-medium">
        <ExternalLink className="w-3.5 h-3.5" /> {t('brain.clients.form.view_pr')}
      </a>
      {children}
    </div>
  );
}
